import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants, getFormattedEventDate } from "@qgiv/core-js";
import {
    selectReceipt,
    selectReceiptId,
} from "../../../redux/slices/receiptSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import {
    selectCmsControlByIdByPage,
    selectThemeSettings,
} from "../../../redux/slices/cmsSettingsSlice";
import { selectConfig } from "../../../redux/slices/configSlice";
import { ThemeType } from "../../../redux/constants";
import ReceiptHeader from "./ReceiptHeader";

const ConnectedReceiptHeader = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const config = useSelector(selectConfig);
    const { HTTP_HOST } = config;
    const receiptId = useSelector(selectReceiptId);
    const receipt = useSelector(selectReceipt);
    const formSettings = useSelector(selectAllFormSettings);
    const { title } = formSettings;
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { alias, endDate, startDate, timezone } = p2pSettings;
    const { transaction } = receipt;
    const { id } = transaction;
    const formattedDateString = getFormattedEventDate({
        startDate,
        endDate,
        timezone,
    });
    const eventTitle = title;
    const transactionId = id;
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.HEADER, state),
    );
    const {
        regHeaderSettings: { displayEventDate },
    } = themeSettings;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { heading = "You are registered for %EventName%" },
    } = control;

    const renderHeading = heading.includes("%EventName%")
        ? (_heading) => (
              <h1>
                  {_heading.split("%EventName%")[0]}
                  <a
                      href={`${HTTP_HOST}/event/${alias}`}
                      target="_blank"
                      rel="noreferrer"
                  >
                      {eventTitle}
                  </a>
                  {_heading.split("%EventName%")[1]}
              </h1>
          )
        : () => {};

    const receiptHeaderProps = {
        formattedDateString,
        transactionId,
        heading,
        renderHeading,
        displayEventDate,
        controlId,
        receiptId,
    };

    return <ReceiptHeader {...receiptHeaderProps} />;
};

ConnectedReceiptHeader.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptHeader;
